import { render, staticRenderFns } from "./EquipoEstado.vue?vue&type=template&id=b0a9d1b8"
import script from "./EquipoEstado.vue?vue&type=script&lang=js"
export * from "./EquipoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports